import { createContext } from 'react'
import { DEALER } from '~/types'

type USER = {
  name?: string
  id?: number
  description?: string
  email?: string
}

type SESSION = {
  langId?: number
  dealerId?: number
}

interface Props {
  auth: {
    type?: string
  }
  user: USER
  session: SESSION
  dealers: DEALER[]
  currentDealer: DEALER
}

const UserContext = createContext<Props>({
  auth: {},
  user: {},
  session: {},
  dealers: [],
  currentDealer: {
    id: 0,
    uuid: '',
    name: '',
    api_key: '',
    // @ts-ignore
    type: null,
  },
})

export default UserContext
